import { render, staticRenderFns } from "./EmployerMatchPostTaxContributionsRadio.vue?vue&type=template&id=c10bb788&"
import script from "./EmployerMatchPostTaxContributionsRadio.vue?vue&type=script&lang=js&"
export * from "./EmployerMatchPostTaxContributionsRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports